/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialCompanyDiscountRequest } from '../../models/editorial-company-discount-request';

export interface CreateEditorialCompanyDiscount$Params {
  companyId: number;
      body: EditorialCompanyDiscountRequest
}

export function createEditorialCompanyDiscount(http: HttpClient, rootUrl: string, params: CreateEditorialCompanyDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createEditorialCompanyDiscount.PATH, 'post');
  if (params) {
    rb.query('companyId', params.companyId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

createEditorialCompanyDiscount.PATH = '/api/editorial/companies/{id}/discounts';
